import * as PIXI from 'pixi.js';
import {GameObject} from "../../base/GameObject";
import {MovieMold} from "../library/MovieMold";
import {LibraryFlump} from "../library/LibraryFlump";
import {Button} from "./Button";

export class TabButton extends Button {

  protected _upState!: PIXI.Container;
  protected _downState!: PIXI.Container;

  constructor(mold: MovieMold, library: LibraryFlump) {
    super(mold, library);
  }

  protected _isSelected = false;

  public get isSelected(): boolean {
    return this._isSelected;
  }

  public set isSelected(value: boolean) {
    if (this._isSelected == value) {
      return;
    }
    this._isSelected = value;
    if (value) {
      this._upState.visible = true;
      this._downState.visible = false;
    } else {
      this._upState.visible = false;
      this._downState.visible = true;
    }
    this.onSelectedStateChange();
  }

  override build() {
    super.build();
    this._upState = this._btnContent.getChildByLabel(LibraryFlump.FLUMP_STATE_UP)!;
    this._downState = this._btnContent.getChildByLabel(LibraryFlump.FLUMP_STATE_DOWN)!;
  }

  override destroy() {
    GameObject.destroy(this._upState);
    GameObject.destroy(this._downState);
    super.destroy();
  }

  protected override onTouch() {
    this._upState.visible = true;
    this._downState.visible = false;
  }

  protected override onUnTouch() {
    this._upState.visible = false;
    this._downState.visible = true;
  }

  protected onSelectedStateChange() {

  }

}
